<template>
    <div class="row pt-2">
        <div class="col-sm-12 col-md-6">
            <a
                :href="
                    '/export-price-list/' +
                    modalData.pricelist_id +
                    '/format/pdf'
                "
                target="_blank"
                class="my-3 btn add-button btn btn-action float-right"
                >Export to PDF</a
            >
        </div>
        <div class="col-sm-12 col-md-6">
            <a
                :href="
                    '/export-price-list/' +
                    modalData.pricelist_id +
                    '/format/excel'
                "
                target="_blank"
                class="my-3 btn add-button btn btn-action float-right"
                >Export to Excel</a
            >
        </div>
    </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
    props: ["modalData"],
    emits: ["closeModal"],
    components: {},
    setup() {
        const store = useStore();

        return {};
    },
    data() {
        return {
            form: {
                id: null,
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
            },
        };
    },
    mounted() {
        console.log("this.modalData", this.modalData);
    },
    methods: {},
};
</script>
